/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Remark Code Field Component
 */
import React from 'react';
import _ from 'lodash';
import { Flex, Typography } from 'antd';
import { MultiSelect } from 'lib/antd';

import remarkCodes from 'app-constants/claims/remarkCodes.json';

const remarkCodesOptions = _.map(remarkCodes, ({ code }) => ({ label: code, value: code }));

const RemarkCode: React.FC<{ value: AnyType; isEditing: boolean; onChange: (value: AnyType) => void }> = ({
	value,
	isEditing,
	onChange,
}) => {
	if (isEditing) {
		return <MultiSelect value={value} options={remarkCodesOptions} onChange={onChange} placeholder='Select remark codes' />;
	}

	const labels = _.map(value, (code) => `${_.find(remarkCodes, { code })?.code} - ${_.find(remarkCodes, { code })?.display}`);
	if (!_.isEmpty(labels)) {
		return (
			<Flex align='start' justify='center' vertical className='h-full'>
				{_.map(labels, (label, index) => (
					<Typography.Text key={index}>{label}</Typography.Text>
				))}
			</Flex>
		);
	}

	return null;
};

export default RemarkCode;
